import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StandardModal, { ModalSize } from '../../Fundamentals/Modal/StandardModal';
import FormField from '../../Fundamentals/Form/FormField';
import { packageStatusConfig } from './packageConstants';
import type { VossVersionStatus } from '../../../Constants/VOSS/vossVersionStatus';

interface CreatePackageVersionModalProps {
    sourceVersionLabel: string;
    sourceStatus: VossVersionStatus | undefined;
    isSaving: boolean;
    onCreate: (comment: string) => void;
}

const CreatePackageVersionModal = ({ sourceVersionLabel, sourceStatus, isSaving, onCreate }: CreatePackageVersionModalProps) => {
    const { t } = useTranslation();
    const [comment, setComment] = useState('');

    const source = sourceStatus === undefined ? sourceVersionLabel : `${sourceVersionLabel} (${t(packageStatusConfig[sourceStatus].labelKey)})`;

    return (
        <StandardModal
            title={t('packages.createVersion')}
            size={ModalSize.SMALL}
            isLoading={isSaving}
            submitLabel={t('packages.createVersionConfirm') ?? ''}
            cancelLabel={t('common.cancel') ?? ''}
            onSubmit={() => onCreate(comment.trim())}
        >
            <p>{t('packages.createVersionText', { version: source })}</p>
            <FormField label={t('packages.versionComment') ?? ''} htmlFor="new-version-comment" help={t('packages.versionCommentHelp') ?? ''}>
                <textarea id="new-version-comment" className="form-control" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
            </FormField>
        </StandardModal>
    );
};

export default CreatePackageVersionModal;
